import { Button } from "@mui/material";
import InstagramIcon from "@mui/icons-material/Instagram";
import { Icon } from "@iconify/react/dist/iconify.js";
import { isMobile } from "react-device-detect";
import { StickyHeader } from "../../intro/components/landing-new";
import { communityURL, instagramURL } from "../../utils/constants";
import { useTranslation } from "react-i18next";

export default function SocialLinks() {
  const { t } = useTranslation();

  return (
    <div className="tw-relative tw-flex tw-min-h-screen tw-flex-col tw-items-center tw-justify-center tw-overflow-hidden tw-p-4">
      <StickyHeader />
      <video
        autoPlay
        loop
        muted
        playsInline
        className="tw-absolute tw-left-0 tw-top-0 tw-z-0 tw-h-full tw-w-full tw-object-cover"
      >
        <source
          src={
            isMobile
              ? "https://d1puf2nnbcyl9q.cloudfront.net/mobile_landing.mov"
              : "https://d1puf2nnbcyl9q.cloudfront.net/desktop_landing.mp4"
          }
          type="video/mp4"
        />
        Your browser does not support the video tag.
      </video>

      <div className="tw-relative tw-z-10 tw-w-full tw-max-w-md tw-space-y-6 tw-rounded-lg tw-bg-black tw-bg-opacity-70 tw-p-6 tw-shadow-xl tw-backdrop-blur-md">
        <h1 className="tw-text-center tw-text-3xl tw-font-bold tw-text-white">
          {t("social_links.connect_with_sotravel")}
        </h1>
        <p className="tw-text-center tw-text-gray-300">{t("social_links.follow_us")}</p>

        <div className="tw-space-y-4">
          <Button
            className="tw-flex tw-w-full tw-transform tw-items-center tw-justify-center tw-space-x-2 tw-rounded-full tw-bg-gradient-to-r tw-from-purple-600 tw-to-pink-600 tw-px-4 tw-py-3 tw-font-bold tw-text-white tw-transition tw-duration-300 tw-ease-in-out hover:tw-scale-105 hover:tw-from-purple-700 hover:tw-to-pink-700"
            onClick={() => window.open(instagramURL, "_blank")}
          >
            <InstagramIcon className="tw-h-6 tw-w-6 tw-text-white" />
            <span className="tw-text-white">{t("social_links.instagram")}</span>
          </Button>

          <Button
            className="tw-flex tw-w-full tw-transform tw-items-center tw-justify-center tw-space-x-2 tw-rounded-full tw-bg-gradient-to-r tw-from-blue-400 tw-to-blue-600 tw-px-4 tw-py-3 tw-font-bold tw-text-white tw-transition tw-duration-300 tw-ease-in-out hover:tw-scale-105 hover:tw-from-blue-500 hover:tw-to-blue-700"
            onClick={() => window.open(communityURL, "_blank")}
          >
            <Icon icon="mdi:people" className="tw-h-6 tw-w-6 tw-text-white" />
            <span className="tw-text-white">{t("social_links.community")}</span>
          </Button>
        </div>

        <p className="tw-mt-6 tw-text-center tw-text-sm tw-text-gray-300">
          {t("social_links.tag_us")}
        </p>
      </div>
    </div>
  );
}
